import { future, tailwind } from '@theme-ui/presets'
export default {
  ...future.colors,
  primary: `#60654d`, // tailwind.colors.blue[6],
  secondary: tailwind.colors.pink[6],
  background: tailwind.colors.gray[0],
  backgroundLight: tailwind.colors.gray[0],
  shadeBlue: `#E5BA51`, // tailwind.colors.blue[3],
  shadePink: tailwind.colors.pink[3],
  backgroundBlue: `#fcf8ed`, // tailwind.colors.blue[1],
  primaryLight: `#35382b`, // tailwind.colors.blue[8],
  primaryInBetween: `#4a4f3c`, // tailwind.colors.blue[7],
  textMuted: tailwind.colors.gray[8],
  //  text: `#444`,
  grayDark: tailwind.colors.gray[1],
  //   dark: tailwind.colors.gray[7],
  //   muted: tailwind.colors.gray[5],
  light: tailwind.colors.gray[3],
  lightDarker: tailwind.colors.gray[4],
  grayLighter: `#232b38`,
  yellow: `yellow`,
}
